/**
 * Mirrors backend/utils/cronJobs.js parseDuration for expected deadline.
 * @param {string | undefined} str e.g. "2 Days", "3 hours"
 * @returns {number} milliseconds
 */
export function parseDuration(str) {
  if (!str) return 0;
  const match = String(str).match(/^(\d+)\s*(hour|hours|day|days|minute|minutes)$/i);
  if (!match) return 0;
  const value = parseInt(match[1], 10);
  const unit = match[2].toLowerCase();
  switch (unit) {
    case 'hour':
    case 'hours':
      return value * 60 * 60 * 1000;
    case 'day':
    case 'days':
      return value * 24 * 60 * 60 * 1000;
    case 'minute':
    case 'minutes':
      return value * 60 * 1000;
    default:
      return 0;
  }
}

/**
 * Best-effort expected delivery or pickup date for seller planning.
 * Prefer buyer-requested date; else order placed + seller-stated lead time.
 * @param {object} order
 * @returns {Date | null}
 */
export function getExpectedFulfillmentDate(order) {
  if (order.requestedDeliveryDate) {
    const d = new Date(order.requestedDeliveryDate);
    if (Number.isNaN(d.getTime())) return null;
    d.setHours(12, 0, 0, 0);
    return d;
  }
  const durationStr =
    order.deliveryType === 'delivery' ? order.timeToDeliver : order.timeframeToCollect;
  const ms = parseDuration(durationStr);
  if (!ms) return null;
  const created = new Date(order.createdAt);
  return new Date(created.getTime() + ms);
}

export function dateKeyLocal(d) {
  if (!d || Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
